<template>
    <div>
        <v-dialog v-model="dialog" width="700" persistent scrollable>
            <v-card>
                <w-dialog-toolbar
                    :add-action="addAction"
                    :update-action="updateAction"
                    :delete-action="deleteAction"
                    :view-action="viewAction"
                ></w-dialog-toolbar>
                <v-divider></v-divider>
                <v-overlay absolute :value="overlay">
                    <v-row>
                        <v-col>
                            <v-btn
                                depressed
                                :loading="loading"
                                color="error"
                                @click="remove"
                            >
                                {{ $t("common.delete") }}
                                <v-icon right dark>mdi-trash-can</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col>
                            <v-btn depressed color="primary" @click="overlay = false">
                                {{ $t("common.cancel") }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-overlay>
                <v-card-text :style="`background-color: ${cardBackgroundColor}`">
                    <v-container fluid>
                        <v-form ref="form" lazy-validation>
                            <v-card>
                                <v-toolbar flat dense>
                                    <v-toolbar-title>Détails</v-toolbar-title>
                                </v-toolbar>
                                <v-container fluid>
                                    <v-row dense>
                                        <v-col cols="12">
                                            <strong>Nom *</strong>
                                            <w-text-field
                                                v-model="controlProgram.name"
                                                :readonly="readonly"
                                                :rules="[mxRules.required]"
                                            ></w-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <strong>Couleur *</strong>
                                            <w-vuetify-color-picker
                                                v-model="controlProgram.color"
                                                :readonly="readonly"
                                            ></w-vuetify-color-picker>
                                        </v-col>
                                        <v-col cols="6">
                                            <strong>Ordre *</strong>
                                            <w-text-field
                                                v-model="controlProgram.colorOrder"
                                                type="number"
                                                min="1"
                                                :readonly="readonly"
                                                :rules="[mxRules.required]"
                                            ></w-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                            <br/>
                            <v-card>
                                <v-toolbar flat dense>
                                    <v-toolbar-title>Définitions</v-toolbar-title>
                                </v-toolbar>
                                <v-container fluid>
                                    <v-row dense>
                                        <v-col cols="12">
                                            <strong>Conditions</strong>
                                            <v-autocomplete
                                                v-model="controlProgram.programIds"
                                                :items="controlPrograms"
                                                item-value="id"
                                                item-text="name"
                                                outlined
                                                dense
                                                multiple
                                                chips
                                                deletable-chips
                                                :color="inputColor"
                                                :background-color="backgroundColor"
                                                hide-details="auto"
                                            ></v-autocomplete>
                                        </v-col>


                                        <v-col cols="12">
                                            <v-textarea
                                                v-model="controlProgram.description"
                                                :label="'Message *'"
                                                outlined
                                                dense
                                                auto-grow
                                                :color="inputColor"
                                                :background-color="backgroundColor"
                                                hide-details="auto"
                                                :rules="[mxRules.required]"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    [#TOTAL#]
                    <v-spacer/>
                    <v-btn depressed outlined color="primary" @click="getBack">
                        {{ $t("common.close") }}
                        <v-icon right>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                        depressed
                        :loading="loading"
                        color="teal"
                        dark
                        @click="save"
                        v-if="addAction"
                    >
                        {{ $t("common.add") }}
                        <v-icon right>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                    <v-btn
                        depressed
                        :loading="loading"
                        color="orange"
                        dark
                        @click="update"
                        v-if="updateAction"
                    >
                        {{ $t("common.edit") }}
                        <v-icon right>mdi-pencil-box-multiple</v-icon>
                    </v-btn>
                    <v-btn
                        depressed
                        :loading="loading"
                        color="red"
                        dark
                        @click="overlay = true"
                        v-if="deleteAction"
                    >
                        {{ $t("common.delete") }}
                        <v-icon right>mdi-trash-can</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {computed, ref, onMounted} from "vue";
import useSharedData from "@/use/SharedData";
import useValidation from "@/use/Validation";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import {useControlProgramStore} from "@/views/Notification/stores/ControlProgram";
import axios from "axios";

export default {
    name: "ParentFormModel",
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        deleteAction: Boolean,
        viewAction: Boolean,
        category: String,
    },
    setup(props) {
        const readonly = computed(() => props.viewAction || props.deleteAction);
        const {
            filter,
            inputColor,
            backgroundColor,
            cardBackgroundColor,
            dialog,
            loading,
            overlay
        } = useSharedData();
        const {mxRules} = useValidation();
        const {getBack, transformFilterValues} = useSharedMethod();
        const {$route, $refs} = useTools();
        const controlProgramStore = useControlProgramStore();

        const controlProgram = ref({
            color: null,
            isCombine: true,
            isMiddle: false,
            programIds: [],
            category: props.category
        });


        const loadingAll = ref(false);
        const controlPrograms = ref([]);

        function findAll() {
            loadingAll.value = true;
            filter.value.module = $route.params.module;
            filter.value.isMiddle = true;
            filter.value.allRecords = true;
            filter.value.sortBy = "name";
            filter.value.category = props.category;
            axios.get('/controlPrograms', {params: transformFilterValues(filter.value)}).then(response => {
                controlPrograms.value = response.data.elements;
            }).finally(() => {
                loadingAll.value = false;
            })
        }

        function findById() {
            loading.value = true;
            axios.get(`/controlPrograms/${$route.params.id}`).then(response => {
                controlProgram.value = response.data;
            }).finally(() => {
                loading.value = false;
            })
        }

        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                controlProgram.value.module = $route.params.module;
                axios.post('/controlPrograms', controlProgram.value).then(response => {
                    controlProgramStore.addControlProgram(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                })
            }
        }

        function update() {
            if ($refs.form.validate()) {
                loading.value = true;
                controlProgram.value.module = $route.params.module;
                axios.put('/controlPrograms', controlProgram.value).then(response => {
                    controlProgramStore.updateControlProgram(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                })
            }
        }

        function remove() {
            loading.value = true;
            axios.delete(`/controlPrograms/${$route.params.id}`).then(() => {
                controlProgramStore.deleteControlProgram(controlProgram.value);
                getBack();
            }).finally(() => {
                loading.value = false;
            })
        }

        onMounted(() => {
            findAll();
            if (!props.addAction) {
                findById();
            }
        })

        return {
            loadingAll,
            controlPrograms,
            controlProgram,
            readonly,
            mxRules,
            inputColor,
            backgroundColor,
            cardBackgroundColor,
            dialog,
            overlay,
            loading,
            getBack,
            save,
            update,
            remove,
        }
    }
}
</script>

<style scoped>

</style>